import React from "react";
import { X } from "lucide-react";

export default function Modal({
  isOpen,
  onClose,
  title,
  subtitle,
  children,
  className = "",
}) {
  if (!isOpen) return null;

  return (
    <div
      className="overlay"
      onClick={onClose}
    >
      <div
        className={`modal-panel max-h-[90vh] overflow-y-auto ${className}`}
        onClick={(e) => e.stopPropagation()}
      >
        <button
          className="absolute top-4 right-4 flex h-8 w-8 items-center justify-center rounded-lg text-warm-400 hover:text-warm-700 hover:bg-warm-100 transition-colors"
          onClick={onClose}
          title="Fechar"
        >
          <X size={18} />
        </button>

        {/* Header */}
        <div className="px-6 pt-6 pb-4 border-b border-warm-100">
          <h3 className="font-heading text-lg font-bold text-warm-900 pr-8">{title}</h3>
          {subtitle && (
            <p className="mt-1 text-sm text-warm-500">{subtitle}</p>
          )}
        </div>

        {/* Body */}
        <div className="px-6 py-5">{children}</div>
      </div>
    </div>
  );
}
